import { createMutationHelper } from '@utils/swr'
import { type ECommerceUpdatePaymentTransactionInvoiceParams, type UpdatePaymentTransactionInvoiceRequest } from '../types/apiRequest'
import { type ECommerceCartCvsInfoResponse, type UpdatePaymentTransactionInvoiceResponse } from '../types/apiResponse'
import { type ECommerceV2Apis, type FortuneApis } from '../types/apis'

interface UseApiUpdatePaymentTransactionInvoiceParams {
  code: string
  order_hash: string
}

export const { useMutation: useApiUpdatePaymentTransactionInvoice } = createMutationHelper<
  FortuneApis['patch']['updatePaymentTransactionInvoice'],
  UpdatePaymentTransactionInvoiceResponse,
  UpdatePaymentTransactionInvoiceRequest,
  UseApiUpdatePaymentTransactionInvoiceParams
>({
  client: 'fortune',
  key: (params) => {
    const { code, order_hash } = params || {}
    if (!code || !order_hash) return null
    return `/campaigns/${code}/payment_transactions/${order_hash}/invoice`
  },
  fetcher: (url, { arg, client }) => {
    return client.patch(url, arg)
  },
})

export const { useMutation: useApiWordPressUpdatePaymentTransactionInvoice } = createMutationHelper<
  ECommerceV2Apis['patch']['updatePaymentTransactionInvoice'],
  ECommerceCartCvsInfoResponse,
  UpdatePaymentTransactionInvoiceRequest,
  ECommerceUpdatePaymentTransactionInvoiceParams
>({
  client: 'eCommerceV2',
  key: (params) => {
    const { country_code, payment_transaction_id } = params || {}
    if (!country_code || !payment_transaction_id) return null
    return `/${country_code}/payment_transactions/${payment_transaction_id}/invoice`
  },
  fetcher: (url, { arg, client }) => {
    return client.patch(url, arg)
  },
})
